<div class="tooltip flex flex-col cursor-pointer" [class.inline]="inline" [appTooltip]="text" title="">
    <mat-icon class="pointer-events-none" svgIcon="evida_state_information" inline="true"> </mat-icon>
</div>
